import { render, staticRenderFns } from "./ContactPhone.vue?vue&type=template&id=b6edf4ae&scoped=true&"
import script from "./ContactPhone.vue?vue&type=script&lang=js&"
export * from "./ContactPhone.vue?vue&type=script&lang=js&"
import style0 from "./ContactPhone.vue?vue&type=style&index=0&id=b6edf4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6edf4ae",
  null
  
)

export default component.exports